import ProductItemStore from "./ProductItemStore";
import AsnStore from "./AsnStore";
import AsnDetailStore from "./AsnDetailStore";
import CmrDomainStore from "./CmrDomainStore";
import CmrServiceStore from "./CmrServiceStore";
import ShippingMethodStore from "./ShippingMethodStore";
import BrokerStore from "./BrokerStore";
import AbilityStore from "./AbilityStore";
import QuoteStore from "./QuoteStore";


const stores = {
  ProductItemStore,
  AsnStore,
  AsnDetailStore,
  CmrServiceStore,
  CmrDomainStore, 
  ShippingMethodStore,
  BrokerStore,
  AbilityStore,
  QuoteStore
} 

export default stores


// WEBPACK FOOTER //
// ./src/stores/index.js